// You can pass some outer data here
import _ from 'lodash';
import { Message, MessageBox } from 'element-ui';
import { request, autoLoading } from 'beans-admin-plugin';
import QuickUpdate from './components/quick-update';

export default ({ action = {}, handleDeleted = _.noop, handleRefresh = _.noop, isDetail = false } = {}) => {
  return [
    {
      prop: 'id',
      label: '编号',
      width: 80
    },
    {
      prop: 'name',
      label: '产品',
      width: 280,
      renderCell(h, { row }) {
        const { cover, name, subtitle } = row;
        return (
          <div class="flex item-center">
            <el-image src={cover} fit="cover" style={{ width: '50px', height: '50px' }} preview-src-list={[cover]}></el-image>

            <div class="flex column item-start text-left" style="margin-left: 15px">
              <span class="font-12">{name}</span>
              <span class="font-12">{subtitle}</span>
            </div>
          </div>
        )
      }
    },
    {
      prop: 'sale_price',
      label: '原价',
    },
    {
      prop: 'shop_i_id',
      label: '货号'
    },
    {
      prop: 'enabled',
      label: '已上架',
      renderCell: 'bool'
    },
    {
      prop: 'categories',
      label: '分类',
      width: 160,
      renderCell(h, { row }) {
        const categories = _.get(row, 'categories') || [];
        const style = `margin: ${isDetail ? 0 : '-7px'} 0;`;
        return (
          <div class="flex column">
            {
              categories.map(item =>
                <c-link-button to={{ name: 'categories.show', params: { id: item.id } }} style={style}>{ item.human_name }</c-link-button>
              )
            }
          </div>
        )
      }
    },
    {
      prop: 'real_sale_count',
      label: '销售量',
      width: 130,
      sort: 'order_by'
    },
    {
      prop: 'front_end_url',
      label: '小程序页面路径',
      action: ['hide-in-table']
    },
    {
      prop: 'created_at',
      label: '创建时间',
      renderCell: 'time',
      width: 150,
      sort: 'order_by'
    },
    {
      prop: 'updated_at',
      label: '更新时间',
      renderCell: 'time',
      action: ['hide-in-table']
    },
    _.merge({
      prop: 'action',
      label: '操作',
      fixed: 'right',
      edit: true,
      delete: {
        async handler({ row }) {
          await request.delete(`/products/${row.id}`);
          Message.success('删除成功');
          handleDeleted();
        }
      },
      renderCell(h, { row }) {
        return <QuickUpdate product={row} onSuccess={handleRefresh} />
      },
      extraAction(h, { row }) {
        const { id, is_online } = row;
        const handleCommand = async(title, api) => {
          await MessageBox.confirm(`确定${title}?`, `${title}`);
          await autoLoading(
            request.put(`/products/${api}`, { product_ids: [id] })
          );
          Message.success(`${title}成功`);
          handleRefresh();
        }
        return [
          !is_online && {
            text: '上架产品',
            handler: () => handleCommand('上架产品', 'publish')
          },
          is_online && {
            text: '下架产品',
            handler: () => handleCommand('下架产品', 'unpublish')
          }
        ]
      }
    }, action)
  ];
}


export const formColumns = ({ categories = [] } = {}) => [
  {
    prop: 'name',
    label: '产品名',
    form: {
      component: 'input',
      required: true
    }
  },
  {
    prop: 'subtitle',
    label: '副标题',
    form: {
      component: 'input'
    }
  },
  {
    prop: 'category_ids',
    label: '分类',
    form: {
      component: 'select',
      required: true,
      props: {
        multiple: true,
        clearable: true,
        filterable: true,
        options: _.flatten(categories.map(ele => {
          return (ele.children || []).map(item => ({ value: item.id, label: item.human_name }));
        }))
      }
    }
  },
  {
    prop: 'shop_i_id',
    label: '货号',
    form: {
      component: 'input',
      required: true
    }
  },
  {
    prop: 'related_products',
    label: '搭配单品',
    form: {
      component: 'listSelect',
      props: {
        trackBy: 'id',
        label: 'name',
        sort: false,
        defaultValue: [],
        filterColumns: [
          {
            prop: 'name_cont',
            label: '搜索产品',
            props: {
              placeholder: '请输入产品名搜索'
            }
          }
        ],
        onFilter: async (params = {}) => {
          const { data } = await request.get('/products', { ...params });
          return data;
        }
      }
    }
  },
  {
    prop: 'product_pictures',
    label: '主图',
    form: {
      component: 'upload',
      required: true,
      props: {
        limit: 5,
        hint: '图片比例1:1，建议尺寸 750x750',
      }
    }
  },
  {
    prop: 'goods_size_description',
    label: '详情图',
    form: {
      component: 'upload',
      props: {
        limit: 20
      }
    }
  },
  {
    prop: 'enabled',
    label: '是否发布',
    form: {
      component: 'switch',
      props: {
        defaultValue: true
      }
    }
  }
];
